import { useRef } from "react";
import useParsedSearchParams from "./useParsedSearchParams";

/**
 * Make sure the round id ONLY changes when when the params we care about change
 * Enforce it against react strict mode multiple renders
 *
 * Store past ones in a ref and return it if the previous key exists
 * This will cause a lot of bugs if it doesn't return the correct round id
 */
export default function useRoundId({
  uniqueKey,
}: ReturnType<typeof useParsedSearchParams>) {
  const roundIds = useRef<{ [key: string]: number }>({
    [uniqueKey]: Math.random(),
  });
  const roundId = roundIds.current[uniqueKey];

  if (roundId) {
    return roundId;
  }

  return (roundIds.current[uniqueKey] = Math.random());
}
